/**
 * useAntifraud — сверка форм Директа со сделками Bitrix (воронка КОММА).
 */

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import { type Period, periodQuery, periodKey } from '@/components/ui/PeriodPicker';

export interface AntifraudReport {
  configured: boolean;
  period?: { from: string; to: string; days: number };
  direct?: { forms: number; formsKomma: number };
  crm?: {
    dealsCreated: number;
    fromDirect: number;
    funnel: { stageId: string; name: string; count: number }[];
    won: { count: number; sum: number };
    lost: number;
    utmCoverage: { withUtm: number; total: number; pct: number };
  };
  quality?: { formsToDeals: number | null };
  perCampaign?: {
    campaignId: number | null;
    campaign: string;
    directForms: number | null;
    crmDeals: number;
    won: number;
  }[];
}

export function useAntifraud(period: Period) {
  return useQuery<AntifraudReport>({
    queryKey: ['crm', 'antifraud', periodKey(period)],
    queryFn: () => apiFetch<AntifraudReport>(`/api/crm/antifraud?${periodQuery(period)}`),
    staleTime: 120_000,
    placeholderData: keepPreviousData,
  });
}
